export default {
  errors: {
    required: 'This field is required.',
    requiredMany: 'One or more of the following fields are required',
    email: 'This field must be a valid email address.',
    min: 'This field must be at least {min} characters.',
    max: 'This field must be less than {max} characters.',
    between: 'This field must be between {min} and {max} characters.',
    alpha: 'This field may only contain alphabetic characters.',
    alphaNum: 'This field may only contain alpha-numeric characters.',
    numeric: 'This field may only contain numeric characters.',
    integer: 'This field may only contain a numeric value.',
    decimal: 'This field may only contain a decimal value.',
    url: 'This field is not a valid URL.',
    regex: 'This field format is invalid.',
    date: 'This field is not a valid date.',
    dateFormat: 'This field must be in the format {format}.',
    dateBetween: 'This field must be between {min} and {max}.',
    mustHaveSelected: 'Please make a selection',
    hostname: 'This field must be a valid hostname.',
    apiPath: 'This field must be a valid API Path.',
    betweenValue: 'This field must be between {min} and {max}.',
    betweenPercentage: 'Please provide a percentage between {min} and {max}%',
    validExpiration: 'Card expiration must be greater than 60 days.',
    validDateString: 'Invalid date/format. Expected MM/YY.',
    sameAs: 'Your passwords do not match.',
    maximumRefund: 'You cannot provide a refund for more than {displayedAmount}.',
    betweenRefund: 'You can only refund up to the maximum number of items purchased.',
    numberGreaterThan: 'Please enter a number greater than {min}.',
    ratingRequired: 'Please enter a rating!',
    timeLimit: 'Videos must be less than 30 seconds',
    upload: 'Failed to upload file. Please try again.',
    sizeLimit: 'File size must be less than 100MB.',
  },
};
